import { combineReducers } from "redux";
import CountReduser from "./supplierReduser";

const rootReduser = combineReducers({Eddi:CountReduser});

export default rootReduser;